import { ACCOUNT_AUTH_FLYOUT_MODAL_ID, ALL } from '../../../utils/constants';

export function isLongTextLocale(locale: string): boolean {
  const longTextLocales = ['de-DE'];
  return longTextLocales.includes(locale);
}

export const getIconClass = (iconClassTag: string): string => {
  const lastIndex = iconClassTag.lastIndexOf('/');
  if (lastIndex !== -1) {
    return iconClassTag.substring(lastIndex + 1);
  }
  return iconClassTag;
};

export function enableLoggedInPanel(obj?: Record<string, unknown>, currentUrl?: string): boolean {
  if (!obj || typeof obj !== 'object') return false;

  // Only return true if modalId matches AND smartHubEnabledPages exists and includes currentUrl
  const modalIdMatch = (obj as Record<string, unknown>)['modalId'] === ACCOUNT_AUTH_FLYOUT_MODAL_ID;
  const smartHubEnabledPages = (obj as Record<string, unknown>)['smartHubEnabledPages'] as string | undefined;

  if (modalIdMatch && smartHubEnabledPages && currentUrl) {
    const url = new URL(currentUrl, window.location.origin);
    const path = url.pathname + url.search;
    const enabled = smartHubEnabledPages
      .split(',')
      .map(s => s.trim())
      .some(enabledPath => enabledPath.toLowerCase() === ALL || path.includes(enabledPath));
    if (enabled) return true;
  }

  // Recursively check nested :items if present
  if (obj[':items']) {
    return Object.values(obj[':items'] as Record<string, unknown>).some(v =>
      enableLoggedInPanel(v as Record<string, unknown>, currentUrl)
    );
  }
  return Object.values(obj).some(value =>
    typeof value === 'object' && value !== null
      ? enableLoggedInPanel(value as Record<string, unknown>, currentUrl)
      : false
  );
}
